var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mycontent"},[_c('el-button',{attrs:{"icon":"el-icon-d-arrow-left","type":"info","plain":"","size":"small"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(_vm._s(_vm.$t('m.back')))]),_c('h2',[_vm._v(_vm._s(_vm.$t('m.ds_detail')))]),_c('common',{attrs:{"id":_vm.$route.query.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }